import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useWishlist } from '../contexts/WishlistContext';
import { useCart } from '../contexts/CartContext';
import { Button } from '../components/ui/button';
import { Heart, ShoppingCart, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export const Wishlist = () => {
  const { wishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = (item) => {
    addToCart({
      id: item.product_id,
      name: item.product_name,
      images: [item.product_image],
      price: item.price
    });
    toast.success('Added to cart');
  };

  if (wishlist.length === 0) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-16 text-center">
        <Heart size={64} className="mx-auto text-gray-300 mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Your wishlist is empty</h2>
        <p className="text-gray-500 mb-6">Save items you like for later</p>
        <Link to="/products">
          <Button className="bg-orange-600 hover:bg-orange-700">Browse Products</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-orange-800 mb-8">My Wishlist ({wishlist.length})</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {wishlist.map((item) => (
          <div key={item.product_id} className="bg-white rounded-xl shadow-sm overflow-hidden group">
            <Link to={`/product/${item.product_id}`}>
              <div className="aspect-square overflow-hidden bg-orange-50">
                <img
                  src={item.product_image || 'https://images.pexels.com/photos/5702290/pexels-photo-5702290.jpeg?auto=compress&cs=tinysrgb&w=400'}
                  alt={item.product_name}
                  className="w-full h-full object-cover group-hover:scale-105 transition"
                />
              </div>
            </Link>
            <div className="p-3">
              <Link to={`/product/${item.product_id}`}>
                <h3 className="font-medium text-gray-800 text-sm line-clamp-2 hover:text-orange-600">
                  {item.product_name}
                </h3>
              </Link>
              <p className="text-orange-600 font-bold mt-1">₹{item.price}</p>
              <div className="flex gap-2 mt-3">
                <Button
                  size="sm"
                  onClick={() => handleAddToCart(item)}
                  className="flex-1 bg-orange-600 hover:bg-orange-700 text-xs"
                >
                  <ShoppingCart size={14} className="mr-1" /> Add
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => removeFromWishlist(item.product_id)}
                  className="text-red-500 hover:bg-red-50"
                >
                  <Trash2 size={14} />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
